import PropTypes from 'prop-types';
import React from 'react';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { formatPercent, getLevel } from './format';
import { getLevelColor } from './colors';

/**
 * Yüzdelik bir ölçüyü (servis seviyesi, cevaplama oranı, doluluk) eşiğine
 * göre renklendirilmiş rozet olarak yazar. Sayıyı okumadan da durum görünür.
 */
const LevelBadge = ({ value, decimals = 1 }) => {
  const theme = useTheme();
  const color = getLevelColor(theme, getLevel(value));

  return (
    <Box
      component="span"
      sx={{
        display: 'inline-block',
        // Sabit genişlik: %9,5 ile %100,0 aynı boyda dursun, sütun içinde
        // rozetler satırdan satıra büyüyüp küçülmesin.
        minWidth: 64,
        textAlign: 'center',
        px: 1,
        py: '3px',
        borderRadius: 5,
        fontSize: '0.75rem',
        fontWeight: 500,
        fontVariantNumeric: 'tabular-nums',
        color: color.text,
        backgroundColor: color.bg
      }}
    >
      {formatPercent(value, decimals)}
    </Box>
  );
};

LevelBadge.propTypes = {
  value: PropTypes.number,
  decimals: PropTypes.number
};

export default LevelBadge;
